import React from "react";
import { useNavigate } from "react-router-dom";
import { NoteDropdownProps, WsQParamType } from "../../models/workflowModels";
import { FlexibleContainer } from "../../components/containers/styledComponents";
import { CompassDropdown } from "../../components/visuals/CompassDropdown";
import {
  CompassParagraph,
  StyledAnchor,
} from "../../components/common/styledComponents";

import { ROUTES } from "../../routes/routeNames";
import { blueText, greyText } from "../../styles";
import { MESSAGES } from "../../messages";

export const NoteDropdown = (
  dropdownCustomProps: NoteDropdownProps
): JSX.Element => {
  const navigate = useNavigate();
  const buildSearchParams = (
    id: string,
    idType: "taskId" | "noteId"
  ): string => {
    const params = new URLSearchParams({
      [idType]: id,
    }).toString();
    return `?${params}`;
  };

  return (
    <FlexibleContainer fw="wrap" ml={"15px"} jc="flex-start" ai="center">
      <CompassDropdown {...dropdownCustomProps}>
        <StyledAnchor
          onClick={(): void => {
            navigate({
              pathname: `${ROUTES.WORKSPACE}/${WsQParamType.ADD_NOTE}`,
              search: buildSearchParams(dropdownCustomProps.taskId, "taskId"),
            });
          }}
          hoverUnderline={true}
          color={blueText}
        >
          <CompassParagraph
            key={"add-note"}
            fontSize={12}
            color={blueText}
            cursor="pointer"
            hoverUnderline={true}
          >
            {MESSAGES.WORKSPACE.ADD_NOTE}
          </CompassParagraph>
        </StyledAnchor>
        {dropdownCustomProps.notes?.map((note, index) => (
          <StyledAnchor
            onClick={(): void => {
              navigate({
                pathname: `${ROUTES.WORKSPACE}/${WsQParamType.VIEW_NOTE}`,
                search: buildSearchParams(note.note_id, "noteId"),
              });
            }}
            hoverUnderline={true}
            color={greyText}
            key={`anchor-${index}`}
          >
            <CompassParagraph
              key={index}
              fontSize={12}
              color={greyText}
              cursor="pointer"
            >
              {note.title}
            </CompassParagraph>
          </StyledAnchor>
        ))}
      </CompassDropdown>
    </FlexibleContainer>
  );
};
